import { AdditionalInfoModalFormData } from './types';
import { ProfileAdditionalInfoToBackend } from 'app/api/services/client/client-profile/types';

import { API, ResponseStatus } from 'app/api';
import { Response } from 'app/api/utils/default-request-service';
import { tFunction } from 'app/lang';

import dictionary from './AdditionalInfoModal.dictionary.json';

export type ErrorMessageKey = keyof typeof getDataErrorMessage;

export const getDataErrorMessage = (t: tFunction) => ({
  [ResponseStatus.UNPROCESSABLE_ENTITY]: t(dictionary.unprocessableEntity),
  [ResponseStatus.INTERNAL_SERVER]: t(dictionary.internalServer),
});

export const prepareDataForBackend = ({
  form,
  variant,
}: {
  form: AdditionalInfoModalFormData;
  variant: 'city' | 'vatNumber' | 'email';
}): ProfileAdditionalInfoToBackend => {
  switch (variant) {
    case 'city':
      return { city: form.value };
    case 'vatNumber':
      return { vatNumber: form.value };
    case 'email':
      return { email: form.value };
  }
};

type ApiType = (requestData: ProfileAdditionalInfoToBackend) => Response<unknown, void>;
export const getApiMethod = (variant: 'city' | 'vatNumber' | 'email'): ApiType => {
  switch (variant) {
    case 'city':
      return API.client.clientProfile.saveProfileCity;
    case 'vatNumber':
      return API.client.clientProfile.saveProfileVatNumber;
    case 'email':
      return API.client.clientProfile.saveProfileEmail;
  }
};
